import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {updateLikeFeed, fetchLikeFeed} from "../../../actions/feedAction"; 
import {updateLikeGallery, fetchLikeGallery} from "../../../actions/mediaAction";

import './FeedFooterLike.css';
import LikeModal from './LikeModal';
import iconPath from "./../../../helpers/iconHelper";
import { getlanguagelist } from "../../../helpers/changelanguage";



class FeedFooterLike extends Component {
  constructor(props) {
    super(props);

    this.state = {
     
      modal_open          : false,
      reactionList        : {},
      myReaction          : (this.props.my_reaction != '') ? this.props.my_reaction : ((window.location.href.includes('album') || window.location.href.includes('promotion')) ? 'DEFAULTREACTIONBLACK' : 'DEFAULTREACTION'),
      totalReaction       : this.props.total_reaction,
      changemyReaction    : (this.props.my_reaction != '') ? this.props.my_reaction : ((window.location.href.includes('album') || window.location.href.includes('promotion')) ? 'DEFAULTREACTIONBLACK' : 'DEFAULTREACTION'),
      changetotalReaction : this.props.total_reaction,
      changefeedId        : this.props.feed_id,
      changeNamelikeuser  : null,
      likeresponseid      : null
    };
    this.updateLikeFeeds = this.updateLikeFeeds.bind(this);
    this.fetchLikeFeed   = this.fetchLikeFeed.bind(this);
    this.handleClose     = this.handleClose.bind(this);
    this.openPopup       = this.openPopup.bind(this);
  }

  componentDidMount(){
    
  }

  updateLikeFeeds(dataType,contentId,reaction){
    //console.log('fetchLikeFeed',dataType,contentId,reaction);    
    if((dataType == 'POST') || (dataType == 'ALBUM') || (dataType == 'Promotion') || (dataType == 'POLL') || (dataType == 'GAME POST')){
      let reqParam = {
        comment_type : dataType,
        content_id   : contentId,
        reaction     : ((this.state.changemyReaction == reaction) && (this.state.changefeedId == contentId))? `UN${reaction}` : reaction
      };
      this.props.updateLikeFeed(reqParam);
    }else if (dataType == 'GALLERY IMAGE'){
      let reqParam = {
        user_id   : 6,
        image_id  : contentId,
        reaction  : ((this.state.changemyReaction == reaction) && (this.state.changefeedId == contentId))? `UN${reaction}` : reaction
      };
      this.props.updateLikeGallery(reqParam);
    }
  }

  fetchLikeFeed(feedId,dataType){
   
    if((dataType == 'POST') || (dataType == 'ALBUM') || (dataType == 'Promotion') || (dataType == 'POLL')){
      const param = {
        flag        : dataType,
        feed_id     : feedId,
        return_type : 'OTHERS'
      }
      this.props.fetchLikeFeed(param);
      this.setState({
        modal_open : true
      });
    }else if (dataType == 'GALLERY IMAGE'){
      const param = {
        image_id       : feedId,
        return_type    : 'OTHERS',
      }
      this.props.fetchLikeGallery(param);
      this.setState({
        modal_open : true
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps,prevProps) {
    
    this.setState({
      myReaction          : (nextProps.my_reaction != '') ? nextProps.my_reaction : ((window.location.href.includes('album') || window.location.href.includes('promotion')) ? 'DEFAULTREACTIONBLACK' : 'DEFAULTREACTION'),
      totalReaction       : nextProps.total_reaction,
      changemyReaction    : (nextProps.my_reaction != '') ? nextProps.my_reaction : ((window.location.href.includes('album') || window.location.href.includes('promotion')) ? 'DEFAULTREACTIONBLACK' : 'DEFAULTREACTION'),
      changetotalReaction : nextProps.total_reaction,
      changefeedId        : nextProps.feed_id,
    });
    
    
    if(nextProps.reactionList != prevProps.reactionList){
      this.setState({
        reactionList : nextProps.reactionList
      });
    }

    if((nextProps.updatelikelist != prevProps.updatelikelist) && (Object.keys(nextProps.updatelikelist).length > 0)){
     
      this.setState({
        changemyReaction    : (nextProps.updatelikelist.my_reaction != '') ? nextProps.updatelikelist.my_reaction : 'DEFAULTREACTION',
        changetotalReaction : nextProps.updatelikelist.total_reaction,
        changefeedId        : (this.props.position == 'media') ? nextProps.updatelikelist.imgid : ((nextProps.updatelikelist.data_type == 'Promotion') ? nextProps.updatelikelist.post_id : nextProps.updatelikelist.feed_id),
        changeNamelikeuser  : nextProps.updatelikelist.feed_reaction_details,
        likeresponseid      : (this.props.position == 'media') ? nextProps.updatelikelist.imgid : ((nextProps.updatelikelist.data_type == 'Promotion') ? nextProps.updatelikelist.post_id : nextProps.updatelikelist.feed_id),
      });
    }
    localStorage.setItem("new_polling", 'end');
  }

  handleClose(){
    this.setState({
        modal_open : false
      
    });
   
  };
  
  openPopup(dataType,feedId){
    //console.log('openPopup',feedId);
      window.$('#element_'+feedId).toolbar({
        content   : '#toolbar_options_'+feedId,
        position  : 'top',
        style     : 'primary',
        animation : 'bounce',
      });
      let self = this;
      window.$('#element_'+feedId).off('toolbarItemClick');
      window.$('#element_'+feedId).on('toolbarItemClick',
      function( event,buttonClicked ) {
         let res = (buttonClicked.id).split("_");
         self.updateLikeFeeds(dataType,feedId,res[1]);
      });
  }
  render() {
    let newFeedid = 0;
    //console.log(this.props.lastCreatedPost,newFeedid.feed_id);
    if(this.props.lastCreatedPost.lastPost.post_details != undefined){
      newFeedid = this.props.lastCreatedPost.lastPost.post_details.feed_id
    }
    
    let  languagelist = getlanguagelist();
    let icon_theme = 'light';
    if(window.location.href.includes('album') || window.location.href.includes('album_edit')){
      icon_theme = 'dark';
    }

    let userNamelist = '';
    let feed_reaction_details = this.props.feed_reaction_details; 
    if(this.state.likeresponseid == this.props.feed_id){
      feed_reaction_details = this.state.changeNamelikeuser
    }
    
 

    if(feed_reaction_details != null){
      if(feed_reaction_details.length > 0){
        if(feed_reaction_details.length > 2){
          userNamelist = `<a href="javascript:void(0)"> ${(feed_reaction_details[0].user_id == this.props.loggedinUser.id) ? 'You' : feed_reaction_details[0].full_name}</a> <br/> ${languagelist.and} ${feed_reaction_details.length - 1} ${languagelist.morereact} ${languagelist.reacted} `;
        }else if(feed_reaction_details.length == 2){
          userNamelist = `<a href="javascript:void(0)"> ${(feed_reaction_details[0].user_id == this.props.loggedinUser.id) ? 'You' : feed_reaction_details[0].full_name}, </a>`   
                        + `<a href="javascript:void(0)">  ${(feed_reaction_details[1].user_id == this.props.loggedinUser.id) ? 'You' : feed_reaction_details[1].full_name} </a>`
                          + `<br/> ${languagelist.reacted}`;
        }else{
          userNamelist = `<a href="javascript:void(0)"> ${(feed_reaction_details[0].user_id == this.props.loggedinUser.id) ? 'You' : feed_reaction_details[0].full_name} </a> <br/> ${languagelist.reacted}`;
        }
        
      }
    }
    
    //console.log('fff',this.state.changemyReaction,this.state.myReaction);
    return (
     

      <div className="inline-items">
            <div id={`toolbar_options_${this.props.feed_id}`} className="hidden" >
            <a href={void(0)} id={`${this.props.data_type}_LIKE_${this.props.feed_id}`} >
              <img src={iconPath['LIKE']} />
            </a>
            <a href={void(0)} id={`${this.props.data_type}_DISLIKE_${this.props.feed_id}`} >
              <img src={iconPath['DISLIKE']} />
            </a>
            <a href={void(0)} id={`${this.props.data_type}_LAUGH_${this.props.feed_id}`} >
              <img src={iconPath['LAUGH']} />
            </a>
            <a href={void(0)} id={`${this.props.data_type}_ANGRY_${this.props.feed_id}`} >
              <img src={iconPath['ANGRY']} />
            </a>
            <a href={void(0)} id={`${this.props.data_type}_LOVE_${this.props.feed_id}`} >
              <img src={iconPath['LOVE']} />
            </a>
            <a href={void(0)} id={`${this.props.data_type}_SAD_${this.props.feed_id}`} >
              <img src={iconPath['SAD']} />
            </a>
            <a href={void(0)} id={`${this.props.data_type}_BREAK HEART_${this.props.feed_id}`} >
              <img src={iconPath['BREAKHEART']} />
            </a>
            <div className="clearfix"></div>
          </div>
            <a href={void(0)} className="inline-items">
            <div className="btn-toolbar" id={`element_${this.props.feed_id}`}  onMouseEnter={() => this.openPopup(this.props.data_type,this.props.feed_id)}>
            {
              (this.props.feed_id == this.state.changefeedId) ?  
                <img width="35px" src={iconPath[this.state.changemyReaction]} onClick={()=>this.fetchLikeFeed(this.props.feed_id,this.props.data_type)}/> 
                : <img width="35px" src={iconPath[this.state.myReaction]} onClick={()=>this.fetchLikeFeed(this.props.feed_id,this.props.data_type)}/>
            }
            { /*this.props.feed_id */}
            {/*this.props.data_type */}
            {/*this.props.my_reaction */}
            {/*this.state.myReaction*/}
            </div>
            
            <span style={{color: 'rgb(136, 136, 142)'}}>
           
               { (this.props.feed_id == this.state.changefeedId) ?  this.state.changetotalReaction : this.state.totalReaction }
              
            {/*  {'============'+this.props.feed_id+'==>'+ newFeedid} */}
               
            </span>
            </a>
            {
                (feed_reaction_details == null) ?

                  <ul className="friends-harmonic">
                    <li>
                        <a href={void(0)}>
                            <img src="/assets/images/driver.jpg" alt="friend" style={{width : '100%'}}/>
                        </a>
                    </li>
                    <li>
                        <a href={void(0)}>
                            <img src="/assets/images/driver.jpg" alt="friend" style={{width : '100%'}}/>
                        </a>
                    </li>
                    <li>
                        <a href={void(0)}>
                            <img src="/assets/images/driver.jpg" alt="friend" style={{width : '100%'}}/>
                        </a>
                    </li>
                    <li>
                        <a href={void(0)}>
                            <img src="/assets/images/driver.jpg" alt="friend" style={{width : '100%'}}/>
                        </a>
                    </li>
                    <li>
                        <a href={void(0)}>
                            <img src="/assets/images/driver.jpg" alt="friend" style={{width : '100%'}}/>
                        </a>
                    </li>
                </ul>
                :
                
                  (feed_reaction_details.length > 0) ? 
                    <ul className="friends-harmonic">
                      {   feed_reaction_details.map((item, index) => {
                            return (
                              <li key={`image_${index}`}>
                                <a href={void(0)}>
                                    
                                      <img 
                                          src={(item.image == '') ? iconPath['DEFAULTUSER'] : item.image} 
                                          alt="friend" 
                                          style={{width : '100%', height : '100%', objectFit : 'cover'}} 
                                          className={(this.props.loggedinUser.id == item.user_id) ? 'ownimage' : ''}
                                          onError = {(e) => {
                                            e.target.src = iconPath[DEFAULTUSER]
                                        }} 
                                      />
                                     
                                </a>
                              </li>
                            )
                          })
                      }
                      
                    </ul>
                  :  <ul className="friends-harmonic"></ul>
                
            }
            {
               (feed_reaction_details != null) ?
                  <div className="names-people-likes" onClick={()=>this.fetchLikeFeed(this.props.feed_id,this.props.data_type)}
                      dangerouslySetInnerHTML={{ __html: ' '+userNamelist+ ' ' }}
                  >
                  
                      {/* <a href={void(0)} >Jenny</a>, <a href="#">Robert</a> and
                      <br/>18 more liked this
                      */}
                        
                  </div>
                  :
                  <div className="names-people-likes" onClick={()=>this.fetchLikeFeed(this.props.feed_id,this.props.data_type)}>
                  
                     <a href={void(0)} >Jenny</a>, <a href="#">Robert</a> and
                      <br/>18 more liked this
                     
                        
                  </div>
            }
           
            <LikeModal 
                    key={this.props.feed_id} 
                    handleClose={this.handleClose} 
                    modalOpen={this.state.modal_open}
                    reactionList={this.state.reactionList}
            />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loggedinUser      : state.login.user,
    reactionList      : state.fetchlikelist.likeFeedList,
    updatelikelist    : state.updatelikelist.likeFeedResponse,
    lastCreatedPost   : state.lastpost,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    updateLikeFeed    : bindActionCreators(updateLikeFeed, dispatch),
    fetchLikeFeed     : bindActionCreators(fetchLikeFeed, dispatch),
    fetchLikeGallery  : bindActionCreators(fetchLikeGallery, dispatch),
    updateLikeGallery : bindActionCreators(updateLikeGallery, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedFooterLike);
